module.exports = __webpack_public_path__ + "img/c1.3ba5667f.png";